
import { CheckCircle, Smile, BookOpen, Clock } from "lucide-react";
import { useTranslation } from 'react-i18next';

const Features = () => {
  const { t } = useTranslation();
  const features = [
    {
      icon: <CheckCircle className="text-green-500" size={48} />,
      title: t('landingFeatures.interactiveChecking'),
      description: t('landingFeatures.interactiveCheckingDescription')
    },
    {
      icon: <Smile className="text-yellow-500" size={48} />,
      title: t('landingFeatures.aiGeneratedFun'),
      description: t('landingFeatures.aiGeneratedFunDescription')
    },
    {
      icon: <BookOpen className="text-blue-500" size={48} />,
      title: t('landingFeatures.educationalPlay'),
      description: t('landingFeatures.educationalPlayDescription')
    },
    {
      icon: <Clock className="text-purple-500" size={48} />,
      title: t('landingFeatures.fasterShopping'),
      description: t('landingFeatures.fasterShoppingDescription')
    }
  ];

  return (
    <section id="features" className="py-20 px-4 bg-background">
      <div className="container mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-foreground mb-6">
            {t('landingFeatures.happyFamiliesHappyShopping')}
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            {t('landingFeatures.happyFamiliesHappyShoppingDescription')}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="text-center p-6 rounded-2xl bg-linear-to-br from-muted/50 to-card shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2"
            >
              <div className="mb-4 flex justify-center">
                {feature.icon}
              </div>
              <h3 className="text-xl font-bold text-foreground mb-3">
                {feature.title}
              </h3>
              <p className="text-muted-foreground">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
